<template>
  <div class="timeline-container elevation-1">
    <div class="gray-block">
      <v-layout row wrap class v-if="timeline">
        <v-flex class="timeline-title seguradora-text">Seguradora</v-flex>
        <v-flex
          class="timeline-selector"
          v-for="(item, index) in timeline"
          :key="index"
        >
	  <timeline-item-top
	    :time="getTempoSeguradora(item)"
	    :status="getStatus(item)"
	    :deadline="getDeadline(item)"
	    :name="getNameByType(index)"
	    :has-no-stepper-step="itemsHasNoStepperStep.includes(index)"
	    :is-fulfilled="Object.keys(item).length"
	    :remove-border-left="index == 'proposta'"
	    :remove-border-right="index == 'previsao'"
	    />
        </v-flex>
      </v-layout>
    </div>
    <div class="white-block">
      <v-layout row wrap v-if="timeline">
        <v-flex class="timeline-title corretor-text">Corretor</v-flex>
        <v-flex v-for="(item, index) in timeline" :key="'a' + index">
	  <timeline-item-bottom
	    :status="getStatus(item)"
	    :deadline="getTempoCorretor(item)"
	    :alt-deadline="getDeadline(item)"
	    :has-no-stepper-step="itemsHasNoStepperStep.includes(index)"
	    :is-fulfilled="Object.keys(item).length"
	    :showButton="shouldShowBottomButton(index)"
	    :textButton="textButton"
	    @action-button="$emit('action-button')"
	    />
	</v-flex>
      </v-layout>
      <div class="footer">
        Preencher
        <div class="footer-subtitle">
          <div class="footer-icon green"></div>
          <div class="footer-text">Concluído</div>
        </div>
        <div class="footer-subtitle">
          <div class="footer-icon blue"></div>
          <div class="footer-text">Seguradora</div>
        </div>
        <div class="footer-subtitle">
          <div class="footer-icon orange"></div>
          <div class="footer-text">Corretor</div>
        </div>
        <div class="footer-subtitle">
          <div class="footer-icon red"></div>
          <div class="footer-text">Recusado</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import _ from "lodash";

export default {
  name: "PropostaExpandidaTimeline",
  props: ["timeline", "status", "textButton"],
  data: () => ({
    drawer: null,
    firstLoadServiceRequest: true,
    step: 3,
    itemsHasNoStepperStep: ["proposta", "previsao"],
  }),
  methods: {
    shouldShowBottomButton(type) {
      return {
	'CORRETOR_ANALISE_CREDITO': 'credito',
	'CORRETOR_ANALISE_SUBSCRICAO': 'subscricao',
	'CORRETOR_ANALISE_RESSEGURO': 'resseguro'
      }[this.status] == type;
    },
    getTempoSeguradora(item) {
      return _.get(item, 'tempo_seguradora', false);
    },
    getTempoCorretor(item) {
      return _.get(item, 'tempo_corretor', false);
    },
    getStatus(item) {
      return _.get(item, 'status', false);
    },
    getDeadline(item) {
      return _.get(item, 'data', false);
    },
    getNameByType(type) {
      return {
	"proposta": "Proposta",
	"credito": "Cadastro e Crédito",
	"subscricao": "Subscrição",
	"resseguro":  "Resseguro",
	"emissao": "Emissão",
	"previsao": "Previsão",
      }[type] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .gray-block {
    background-color: #f8f8f8;
    padding-top: 60px;
    padding-left: 25px;
    padding-right: 25px;
  }
  .white-block {
    padding-bottom: 30px;
    padding-right: 25px;
    padding-left: 25px;
  }
  .timeline-container {
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    & /deep/ .flex {
      flex-basis: 0;
    }
  }
  .footer {
    background-color: white;
    margin-top: 50px;
    padding-bottom: 5px;
  }
  .footer-icon {
    float: left;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    display: inline-block;
    margin-left: 15px;
    margin-top: 4px;
  }
  .footer-subtitle:first-of-type .footer-icon {
    margin-left: 0;
  }
  .footer-text {
    float: left;
    font-size: 12px;
    color: #061d45;
    margin-left: 5px;
  }

  .timeline-title {
    font-size: 16px;
    font-weight: bold;
    color: #061d45;
  }
  .timeline-item-container:first-of-type {
    .timeline-item-horizontal-line {
      width: 50%;
    }
  }
  .seguradora-text {
    margin-top: 26px;
  }

  .corretor-text {
    margin-top: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PropostaExpandidaTimeline.vue